import i18n from '@/main';
import http from '@/utils/http';

const baseUrl = '/car';

export default {
    findById(carId) {
        return http.get({
            url: baseUrl + `/${carId}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoCar')
        });
    },

    buscarCarPorCpfCnpjVinculado(cpfCnpj) {
        return http.get({
            url: baseUrl + `/${cpfCnpj}/vinculado`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoCarsVinculados')
        });
    },

    buscarGeometria(codigo) {
        return http.get({
            url: baseUrl + `/geometria/${codigo}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoCar')
        });
    },

    buscarCarPorCpfCnpjVinculadoGeral(cpfCnpj) {
        return http.get({
            url: baseUrl + `/${cpfCnpj}/vinculado-geral`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoCarsVinculados')
        });
    },

    existeVegaApi(codigo) {
        return http.get({
            url: baseUrl + `/${codigo}/existe-vega-api`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.verificandoCar')
        });
    },

    buscarSituacaoCar(codigo) {
        return http.get({
            url: baseUrl + `/situacao/${codigo}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoSituacaoCar')
        });
    },

    listarCarsEmAnalise(filters) {
        let params = `page=${filters.page}&size=${filters.size}&filtro=${filters.filtro}`;
        filters.situacoes.forEach(situacao => {
            params += `&situacoes=${situacao}`;
        });
        return http.get({
            url: `/certificacao/lista-solicitacao-laudo?${params}`,
            lockScreen: false
        });
    },
    detalharAnalise(id) {
        return http.get({
            url: `/certificacao/laudo/${id}`,
            lockScreen: false
        });
    },

    downloadLaudo(id) {
        return http.get({
            url: `/certificacao/laudo-download/${id}`,
            method: 'GET',
            responseType: 'blob'
        });
    }
};
